import axios from "axios";
import { backendURL } from "../url";

const API_URL = `${backendURL}/api/program`;

export const listPrograms = async () => {
  const res = await axios.get(`${API_URL}/programs`);
  return res.data.programs;
};

export const listProgramsByCoachAdmin = async (adminCoachId: string) => {
  // console.log("adminCoachId: ", adminCoachId);
  const res = await axios.post(`${API_URL}/programs/coach-admin`, {adminCoachId}, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  // console.log("coach admin: ", res.data.programs);
  return res.data.programs;
};

export const createProgram = async (data: any) => {
  // If an image file is provided, send multipart form
  if (data.imageFile instanceof File) {
    const form = new FormData();
    form.append("title", data.title);
    form.append("description", data.description);
    form.append("location", data.location);
    form.append("price", String(data.price));
    if (data.isActive !== undefined) form.append("isActive", String(Boolean(data.isActive)));
    if (data.programCoachId) form.append("programCoachId", data.programCoachId);
    form.append("image", data.imageFile);
    const res = await axios.post(`${API_URL}/create-program`, form, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return res.data.program;
  }
  const res = await axios.post(`${API_URL}/create-program`, data, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data.program;
};

export const updateProgram = async (id: string, data: any) => {
  if (data.imageFile instanceof File) {
    const form = new FormData();
    if (data.title) form.append("title", data.title);
    if (data.description) form.append("description", data.description);
    if (data.location) form.append("location", data.location);
    if (data.price !== undefined) form.append("price", String(data.price));
    if (data.isActive !== undefined) form.append("isActive", String(Boolean(data.isActive)));
    if (data.programCoachId !== undefined) form.append("programCoachId", data.programCoachId || "");
    form.append("image", data.imageFile);
    const res = await axios.put(`${API_URL}/programs/${id}`, form, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return res.data.program;
  }
  const res = await axios.put(`${API_URL}/programs/${id}`, data, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data.program;
};

export const deleteProgram = async (id: string) => {
  await axios.delete(`${API_URL}/programs/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const listSessions = async (programId: string) => {
  const res = await axios.get(`${API_URL}/programs/${programId}/sessions`);
  return res.data.sessions;
};

export const createSession = async (programId: string, data: any) => {
  const form = new FormData();
  form.append("name", data.name);
  if (data.startDate) form.append("startDate", data.startDate);
  if (data.endDate) form.append("endDate", data.endDate);
  form.append("capacity", String(data.capacity));
  if (data.isActive !== undefined) form.append("isActive", String(Boolean(data.isActive)));
  if (data.sessionSlotType) form.append("sessionSlotType", data.sessionSlotType);
  if (Array.isArray(data.ageGroups)) form.append("ageGroups", JSON.stringify(data.ageGroups));
  if (data.slotAgeGroups && typeof data.slotAgeGroups === "object") form.append("slotAgeGroups", JSON.stringify(data.slotAgeGroups));
  if (data.slotCapacities && typeof data.slotCapacities === "object") form.append("slotCapacities", JSON.stringify(data.slotCapacities));
  if (data.dayOfWeekTimes && typeof data.dayOfWeekTimes === "object") form.append("dayOfWeekTimes", JSON.stringify(data.dayOfWeekTimes));
  if (data.dateEndOverrides && typeof data.dateEndOverrides === "object") form.append("dateEndOverrides", JSON.stringify(data.dateEndOverrides));
  if (Array.isArray(data.holidays)) form.append("holidays", JSON.stringify(data.holidays));
  if (Array.isArray(data.extraDates)) form.append("extraDates", JSON.stringify(data.extraDates));
  if (data.dayOfWeekDateRanges && typeof data.dayOfWeekDateRanges === "object") form.append("dayOfWeekDateRanges", JSON.stringify(data.dayOfWeekDateRanges));
  if (data.imageFile instanceof File) form.append("image", data.imageFile);
  if (data.sessionCoachOrEmployeeId) form.append("sessionCoachOrEmployeeId", data.sessionCoachOrEmployeeId);

  const res = await axios.post(`${API_URL}/programs/${programId}/sessions`, form, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data.session;
};

export const updateSession = async (id: string, data: any) => {
  const form = new FormData();
  if (data.name) form.append("name", data.name);
  if (data.startDate) form.append("startDate", data.startDate);
  if (data.endDate) form.append("endDate", data.endDate);
  if (data.capacity !== undefined) form.append("capacity", String(data.capacity));
   if (data.isActive !== undefined) form.append("isActive", String(Boolean(data.isActive)));
  if (data.sessionSlotType) form.append("sessionSlotType", data.sessionSlotType);
  if (Array.isArray(data.ageGroups)) form.append("ageGroups", JSON.stringify(data.ageGroups));
  if (data.slotAgeGroups && typeof data.slotAgeGroups === "object") form.append("slotAgeGroups", JSON.stringify(data.slotAgeGroups));
  if (data.slotCapacities && typeof data.slotCapacities === "object") form.append("slotCapacities", JSON.stringify(data.slotCapacities));
  if (data.dayOfWeekTimes && typeof data.dayOfWeekTimes === "object") form.append("dayOfWeekTimes", JSON.stringify(data.dayOfWeekTimes));
  if (data.dateEndOverrides && typeof data.dateEndOverrides === "object") form.append("dateEndOverrides", JSON.stringify(data.dateEndOverrides));
  if (Array.isArray(data.holidays)) form.append("holidays", JSON.stringify(data.holidays));
  if (Array.isArray(data.extraDates)) form.append("extraDates", JSON.stringify(data.extraDates));
  if (data.dayOfWeekDateRanges && typeof data.dayOfWeekDateRanges === "object") form.append("dayOfWeekDateRanges", JSON.stringify(data.dayOfWeekDateRanges));
  if (data.imageFile instanceof File) form.append("image", data.imageFile);
  if (data.sessionCoachOrEmployeeId) form.append("sessionCoachOrEmployeeId", data.sessionCoachOrEmployeeId);

  const res = await axios.put(`${API_URL}/sessions/${id}`, form, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data.session;
};

export const deleteSession = async (id: string) => {
  if (!id) {
    throw new Error("Session id is required");
  }
  await axios.delete(`${API_URL}/sessions/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const listEnrollments = async (sessionId: string) => {
  const res = await axios.get(`${API_URL}/sessions/${sessionId}/enrollments`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data.enrollments;
};

export const listAllEnrollments = async () => {
  const res = await axios.get(`${API_URL}/enrollments`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data.enrollments;
};

export const createEnrollment = async (sessionId: string, data: any) => {
  // console.log("Creating enrollment", data);
  const res = await axios.post(`${API_URL}/sessions/${sessionId}/enrollments`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
  return res.data.enrollment;
};

export const startEnrollmentCheckout = async (sessionId: string, data: any) => {
  // console.log("Session ID from start enrollment checkout", sessionId);
  // console.log("Data from start enrollment checkout", data);
  const res = await axios.post(
    `${API_URL}/sessions/${sessionId}/checkout`,
    data,
    {
      headers: { 
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    }
  );
  return res.data.url as string;
};

export const listCoaches = async () => {
  const res = await axios.get(`${API_URL}/coaches`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data.coaches;
};

export const assignCoach = async (enrollmentId: string, coachId: string) => {
  const res = await axios.put(
    `${API_URL}/enrollments/${enrollmentId}/assign-coach`,
    { coachId },
    { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
  );
  return res.data.enrollment;
};

export const updateEnrollment = async (enrollmentId: string, data: { 
  selectedStartDate?: string;
  timeSlot?: string;
  participantAge?: string;
  paymentStatus?: string;
}) => {
  const res = await axios.put(
    `${API_URL}/enrollments/${enrollmentId}`,
    data,
    { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
  );
  return res.data.enrollment;
};

export const deleteEnrollment = async (enrollmentId: string) => {
  const res = await axios.delete(
    `${API_URL}/enrollments/${enrollmentId}`,
    { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
  );
  return res.data;
};

export const listStaff = async (roles: string[]) => {
  const params = new URLSearchParams();
  if (roles && roles.length) params.set("roles", roles.join(","));
  const res = await axios.get(`${API_URL}/staff?${params.toString()}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data.staff as Array<{ id: string; email: string; name?: string; role: string; firstName?: string; lastName?: string }>;
};

export const getUserEnrollments = async () => {
  const res = await axios.get(`${API_URL}/user-enrollments`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data.enrollments;
};

export const confirmProgramEnrollmentCheckout = async (checkoutSessionId: string) => {
  const res = await axios.get(`${API_URL}/enrollments/confirm-checkout`, {
    params: { session_id: checkoutSessionId },
  });
  return res.data.enrollment;
};

export const syncSessionEnrollments = async (sessionId: string, options?: { force?: boolean }) => {
  const res = await axios.post(
    `${API_URL}/sessions/${sessionId}/enrollments/sync`,
    {},
    {
      params: options?.force ? { force: "1" } : undefined,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
  return res.data.enrollments;
};

export const syncUserEnrollments = async () => {
  const res = await axios.post(`${API_URL}/user-enrollments/sync`, {}, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data.enrollments;
};

export const getEnrollmentReceiptUrl = async (enrollmentId: string) => {
  const res = await axios.get(`${API_URL}/enrollments/${enrollmentId}/receipt`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  return res.data.receiptUrl as string;
};

